import { observer, theme, ui } from "aaa";
import * as _ from "lodash";
import * as React from "react";
import { useState } from "react";
import { isIos } from "util/helpers";
import { LoadingIndicator } from "./georgeComponents";

function hexToRgb(hex: string) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
}

function luminance(hex: string) {
    const rgb = hexToRgb(hex);
    if (!rgb) {
        return 0;
    }

    return (0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b);
}

// This is a drop in replacement for material ui RaisedButton
export const NativeRaisedButton = observer((props: {
    style?: React.CSSProperties,
    buttonStyle?: React.CSSProperties,
    labelStyle?: React.CSSProperties,
    children?: any,
    primary?: boolean, // ignored, but keep here, if needed in future
    secondary?: boolean, // ignored, but keep here, if needed in future
    fullWidth?: boolean,
    label?: string,
    backgroundColor?: string,
    className?: string,
    disabled?: boolean,
    type?: string,
    isLoading?: boolean,

    onClick?: (event: any) => void,
}) => {
    const [hover, setHover] = useState(false);
    const [focus, setFocus] = useState(false);

    const height = (props.style && props.style.height) || 36;
    let backgroundColor = undefined;
    // Keep for reference, if orange buttons are needed
    // let backgroundColor = props.primary ? "#0967AB" : "none";
    // if (props.secondary) {
    //     backgroundColor = "#FF7900";
    // }
    if (props.backgroundColor) {
        backgroundColor = props.backgroundColor;
    }
    if (props.disabled) {
        backgroundColor = ui.isDarkMode ? theme.themeColors.d_grey_200 : "#e5e5e5";
    }

    let l = backgroundColor && _.startsWith(backgroundColor, "#") ? luminance(backgroundColor) : 255;
    if (backgroundColor === undefined) {
        l = 0;
    }
    const highlightColor = l > 180 ? "rgba(0,0,0,0.1)" : "rgba(255,255,255,0.4)";

    let buttonWidth;
    if (props.style && props.style.width) {
        buttonWidth = props.style.width;
    } else if (props.fullWidth) {
        buttonWidth = "100%";
    }

    return (
        <div
            className={props.className}
            style={{
                // boxShadow: focus ? "0px 3px 10px #aaa" : "none", -> new design: no box shadow
                backgroundColor: backgroundColor,
                display: "inline-block",
                width: props.fullWidth ? "100%" : undefined,
                touchAction: "manipulation",
                ...props.style
            }}
        >
            <button
                disabled={props.disabled}
                type={props.type}
                style={{
                    cursor: props.disabled ? "auto" : "pointer",
                    height: height,
                    width: buttonWidth,
                    fontWeight: "bold",
                    background: hover || focus ? highlightColor : "none",
                    padding: 0,
                    border: "none",
                    transition: "all 0.3s",
                    outline: "none",
                    borderRadius: props.style?.borderRadius,
                    overflow: "hidden",
                    touchAction: "manipulation",
                    WebkitTapHighlightColor: "transparent",
                    ...props.buttonStyle
                }}
                onPointerDown={() => {
                    setHover(!props.disabled);
                }}
                onPointerUp={() => {
                    setHover(false);
                }}
                onPointerOut={() => {
                    setHover(false);
                }}
                onTouchStart={() => {
                    if (isIos()) {
                        setHover(!props.disabled);
                    }
                }}
                onTouchEnd={() => {
                    if (isIos()) {
                        setHover(false);
                    }
                }}
                onTouchCancel={() => {
                    if (isIos()) {
                        setHover(false);
                    }
                }}
                // TODO: Use focus frame instead of highlight
                // onFocus={() => {
                //     setFocus(true);
                // }}
                // onBlur={() => {
                //     setHover(false);
                // }}
                onClick={(event) => {
                    if (props.onClick) {
                        props.onClick(event);
                    }
                }}
            >
                {!props.isLoading && <>
                    {props.children}
                    {props.label && <span
                        style={{
                            paddingLeft: 16,
                            paddingRight: 16,
                            fontSize: 14,
                            color: props.disabled ? theme.themeColors.d_grey_100 : "white",
                            ...props.labelStyle
                        }}
                    >
                        {props.label}
                    </span>}
                </>}
                {props.isLoading && <LoadingIndicator isLoading={props.isLoading} height="100%" />}
            </button>
        </div>

    );
});




// WEBPACK FOOTER //
// ./src/components/common/NativeRaisedButton.tsx